const translations = {
  "en": {
    "Failed to delete chat": "Failed to delete chat",
    "Failed to update chat": "Failed to update chat"
  },
  "zh-tw": {
    "Failed to delete chat": "刪除對話失敗",
    "Failed to update chat": "更新對話失敗"
  }
};

export default translations;
